import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { DataGrid, GridColumns, GridRowsProp } from "@mui/x-data-grid";

import TextField from "@mui/material/TextField";

/*  T O O L B A R  */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";

/*  T O O L T I P  */
import Tooltip from "@mui/material/Tooltip";

/* G R I D  */
import Grid from "@mui/material/Grid";

/* C U S T O M I Z A D O  S */
import PropriedadeTopo from "./topo";
import Propriedade from "../../components/classes/Propriedade";
import PropriedadeDataset from "../../components/data/PropriedadeDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import PageHelper from "../../helper/pageHelper";

import Button from "@mui/material/Button";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { UserContext } from "../../App";
import { useTranslation } from "react-i18next";

interface Data {
  id: number;
  propriedade: string;
  valor: string;
  complemento: string;
  rotina: string;
}

export const PropriedadeDetalhe = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);
  const [nada, SetNada] = useState<Propriedade[]>([]);

  const [propriedades, SetPropriedades] = useState<Propriedade[]>([]);
  const [registro, SetRegistro] = useState<Propriedade>(
    () => new Propriedade()
  );
  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<Propriedade>(
    () => new Propriedade()
  );
  const data: PropriedadeDataset = new PropriedadeDataset();

  const [codigoFornecedorSap, setCodigoFornecedorSap] = useState(0);

  const [habilita, setHabilita] = useState(false);
  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(true);

  const [loading, setloading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [columns, setColumns] = useState<GridColumns>([]);
  const [rows, setRows] = useState<Data[]>([]);

  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);

  function createData(
    id: number,
    propriedade: string,
    valor: string,
    complemento: string,
    rotina: string
  ): Data {
    return {
      id,
      propriedade,
      valor,
      complemento,
      rotina,
    };
  }

  useEffect(() => {
    setloading(true);
    data.ListarAtivos().then((result) => {
      SetPropriedades(result);
      setloading(false);
      if (result.length > 0) {
        MontaColunas();
        preencherGrid(result);
      }
    });
  }, []);

  const handleClickNew = () => {
    setHabilita(true);
    SetRegistro(new Propriedade());
  };

  const handlerPropriedadeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, descricao: e.target.value };
    });
  };

  const handlerValorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, valorPadrao: e.target.value };
    });
  };
  const handlerComplementoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, complemento: e.target.value };
    });
  };
  const handlerRotinaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, rotina: e.target.value };
    });
  };

  const handleIncluirClick = () => {
    var parametroToAdd = new Propriedade();
    if (registro.descricao) {
      parametroToAdd.descricao = registro.descricao.toUpperCase();
    }
    parametroToAdd.complemento = registro.complemento;
    parametroToAdd.rotina = registro.rotina;
    parametroToAdd.valorPadrao = registro.valorPadrao;
    data.Adicionar(parametroToAdd);
    Mensagem(
      t("global.message.warning"),
      t("global.message.propertyAddWithSuccess")
    );
    handleClickNew();
    setHabilita(false);
  };

  const handleAtualizaClick = () => {
    var parametroToUpd = new Propriedade();
    parametroToUpd.complemento = registro.complemento;
    parametroToUpd.rotina = registro.rotina;
    parametroToUpd.descricao = registro.descricao;
    parametroToUpd.valorPadrao = registro.valorPadrao;
    parametroToUpd.id = registro.id;
    data.Atualizar(parametroToUpd);
    Mensagem(
      t("global.message.warning"),
      t("global.message.propertyUpdatedWithSuccess")
    );
    handleClickNew();
    setHabilita(false);
  };

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t('global.button.ok'),
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      setItemExcluir(propriedades.filter((f) => f.id === cellValues.row.id)[0]);
      handleClickOpen();
    }
  };

  useEffect(() => {
    if (excluiItem === true) {
      data.Apagar(itemToExcluir);
      localStorage.removeItem("PropriedadeIdSel");
      setMensagem("Parâmetro Excluido com sucesso!");
      setSeverity(0);
      PageHelper.refreshPage();
    }
    setExcluiItem(false);
    setItemExcluir(new Propriedade());
    setRefresh(!refresh);
  }, [excluiItem]);

  const handleSelectionChange = (id: any) => {
    if (id !== null && id !== undefined && id > 0) {
      localStorage.setItem("PropriedadeIdSel", id);
      // eslint-disable-next-line array-callback-return
      propriedades.map(function (item: Propriedade) {
        if (item.id === Number(id)) {
          SetRegistro(item);
          setHabilita(true);
        }
      });
    } else {
      localStorage.removeItem("PropriedadeIdSel");
      setHabilita(false);
    }
  };

  function preencherGrid(_itens: Propriedade[]) {
    setRows(
      _itens.map((_Item: Propriedade) => {
        return createData(
          Number(_Item.id),
          String(_Item.descricao),
          String(_Item.valorPadrao),
          String(_Item.complemento),
          String(_Item.rotina)
        );
      })
    );
    setloading(false);
  }

  function TransitionAlerts(_severity: number, _mensagem: string) {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  }

  function MontaColunas() {
    let columns1: GridColumns = [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "propriedade",
        headerName: "Parâmetro",
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "valor",
        headerName: "Valor",
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "complemento",
        headerName: "Complemento",
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "rotina",
        headerName: "Rotina",
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "deleteico",
        headerName: "",
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        align: "center",
        renderCell: () => {
          return (
            <IconButton disabled={user.isSuporte}>
              {" "}
              <EraseIcon />
            </IconButton>
          );
        },
      },
    ];
    setColumns(columns1);
  }

  return (
    <div className="container">
      <PropriedadeTopo />
      <div className="containerToolbar">
        <Tooltip title="Novo Parâmetro">
          <span>
            <IconButton onClick={handleClickNew} disabled={user.isSuporte}>
              <NewIcon />
            </IconButton>
          </span>
        </Tooltip>
        {registro.descricao.length > 0 && registro.valorPadrao.length > 0 ? (
          <Tooltip title="Atualizar dados da Propriedade">
            <span>
              <IconButton
                onClick={
                  registro.id === 0 ? handleIncluirClick : handleAtualizaClick
                }
                disabled={user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
      <div className="insiderContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id={"Propriedade"}
              name={"Propriedade"}
              label="Propriedade"
              fullWidth
              variant="outlined"
              value={registro.descricao}
              onChange={handlerPropriedadeChange}
              sx={{ minWidth: "150px" }}
              disabled={!habilita}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              id={"Valor"}
              name={"Valor"}
              label="Valor"
              fullWidth
              variant="outlined"
              value={registro.valorPadrao}
              onChange={handlerValorChange}
              disabled={!habilita}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id={"complemento"}
              name={"complemento"}
              label="Complemento"
              fullWidth
              variant="outlined"
              value={registro.complemento}
              onChange={handlerComplementoChange}
              disabled={!habilita}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id={"rotina"}
              name={"rotina"}
              label="Rotina"
              fullWidth
              variant="outlined"
              value={registro.rotina}
              onChange={handlerRotinaChange}
              disabled={!habilita}
            />
          </Grid>
        </Grid>
        <br />
      </div>
      <div className="insiderContainer">
        <>
          <div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Exclusão de Propriedade?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Você solicitou a exclusão do parâmetro.
                  <br />
                  <br />
                  Parâmetro :{" "}
                  <strong>
                    {itemToExcluir.descricao}
                    <strong />
                  </strong>
                  <br />
                  Valor : <strong>{itemToExcluir.valorPadrao}</strong>
                  <br />
                  Confirma a Operação?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  onClick={() => {
                    setExcluiItem(true);
                    handleClose();
                  }}
                >
                  Sim
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleClose}
                  autoFocus
                >
                  Não
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div style={{ height: "50vh", width: "100%" }}>
            <DataGrid
              loading={loading}
              rows={rows}
              rowsPerPageOptions={[50, 100, 250, 500]}
              columns={columns}
              experimentalFeatures={{ newEditingApi: true }}
              onSelectionModelChange={(ids) => {
                handleSelectionChange(ids);
              }}
              key="ContratoItemGrid"
              rowHeight={32}
              onCellClick={(cellValues) => {
                handleClick(cellValues);
              }}
            />
            {mensagem.length > 0 ? TransitionAlerts(severity, mensagem) : null}
          </div>
        </>
      </div>
    </div>
  );
};
